import React from 'react';
import {Input} from './Input';

export const InputBarcode = (props) => {
    let {onBarcode = (barcode) => console.log(barcode), ...otherProps} = props;

    return (
        <Input
            {...otherProps}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    onBarcode(e.target.value);
                }
            }}
        />
    )
};
